import { render, staticRenderFns } from "./AccountManagement.vue?vue&type=template&id=c3578cb4&"
import script from "./AccountManagement.vue?vue&type=script&lang=js&"
export * from "./AccountManagement.vue?vue&type=script&lang=js&"
import style0 from "./AccountManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AccountManagement.vue"
export default component.exports